type EnvReader = Record<string, string | undefined>;

export const FEATURE_FLAGS = {
  mountainExplorer: {
    env: "NEXT_PUBLIC_FF_MOUNTAIN_EXPLORER",
    label: "Zermatt Mountain Explorer",
    gates: "The on-demand mountain explorer on the Zermatt location page.",
    defaultEnabled: false,
  },
  beachExplorer: {
    env: "NEXT_PUBLIC_FF_BEACH_EXPLORER",
    label: "Polzeath Beach Explorer",
    gates: "The on-demand beach explorer on the Polzeath location page.",
    defaultEnabled: false,
  },
  coastalWater3d: {
    env: "NEXT_PUBLIC_FF_COASTAL_WATER_3D",
    label: "Coastal Water 3D",
    gates: "The WebGL coastal Water renderer on the visualiser tool and coastal condition pages.",
    defaultEnabled: false,
  },
} as const;

export type FeatureFlagKey = keyof typeof FEATURE_FLAGS;
export type FeatureFlagSnapshot = Record<FeatureFlagKey, boolean>;

export function parseFeatureFlagValue(value: string | undefined, defaultEnabled = false): boolean {
  if (!value) return defaultEnabled;
  const normalised = value.trim().toLowerCase();
  return normalised === "1" || normalised === "true" || normalised === "yes" || normalised === "on";
}

export function isFeatureFlagEnabled(
  flag: FeatureFlagKey,
  env: EnvReader = process.env,
): boolean {
  if (flag === "mountainExplorer") return env.NEXT_PUBLIC_FF_MOUNTAIN_EXPLORER === "true";
  if (flag === "beachExplorer") return env.NEXT_PUBLIC_FF_BEACH_EXPLORER === "true";
  return parseFeatureFlagValue(env[FEATURE_FLAGS[flag].env], FEATURE_FLAGS[flag].defaultEnabled);
}

export function getFeatureFlagSnapshot(env: EnvReader = process.env): FeatureFlagSnapshot {
  return {
    mountainExplorer: isFeatureFlagEnabled("mountainExplorer", env),
    beachExplorer: isFeatureFlagEnabled("beachExplorer", env),
    coastalWater3d: isFeatureFlagEnabled("coastalWater3d", env),
  };
}
